<template>
  <div>
    <div class="pt-3 text-center">
      <i class="mdi mdi-counter display-4 text-primary d-block"></i>
      <span>{{$t('Components.Widgets.Counter.FeedbackNote')}}</span>
      <!-- Progress -->
      <vs-progress :percent="100" color="primary" class="mt-5">primary</vs-progress>
      <vs-row class="mt-4 mb-3">
        <vs-col vs-lg="6" vs-xs="12" vs-sm="6" class="border-right text-left">
          <h3 class="mb-0 font-medium">{{data ? data.positive : 0}}</h3>{{$t('Components.Widgets.Counter.Positive')}}
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12" vs-sm="6" class="border-right">
          <h3 class="mb-0 font-medium">{{data ? data.negative : 0}}</h3>{{$t('Components.Widgets.Counter.Negative')}}
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>
<script>


export default {
  name: "CounterSummary",
  data: () => ({
    title: "CounterSummary"
  }),
  components: {

  },
  props: {
    data: Object
  }
};
</script>